import { forwardRef } from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import { cn } from '@/lib/utils'

/**
 * Switch — тумблер. ОСОЗНАННОЕ добавление сверх макета (направление B): в макете `.switch` — это
 * строка настройки (см. SettingRow) с обычным чекбоксом, а не тумблер. Те же состояния/доступность.
 * Цвета и фокус-кольцо из токенов.
 */
export const Switch = forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      'inline-flex h-5 w-9 shrink-0 items-center rounded-pill border border-transparent bg-gray px-0.5 outline-none transition-colors',
      'focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-panel',
      'data-[state=checked]:bg-accent',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb className="pointer-events-none size-4 rounded-round bg-white transition-transform data-[state=checked]:translate-x-4" />
  </SwitchPrimitive.Root>
))
Switch.displayName = 'Switch'
